import { render, staticRenderFns } from "./config_dtmf.vue?vue&type=template&id=5742b6a6&scoped=true&"
import script from "./config_dtmf.vue?vue&type=script&lang=js&"
export * from "./config_dtmf.vue?vue&type=script&lang=js&"
import style0 from "./config_dtmf.vue?vue&type=style&index=0&id=5742b6a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742b6a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VCol,VRow,VSelect,VTextField,VTooltip})
